import { useGetCompanyQuery } from "@/api/AppApi/services/company";

const useCanTamara = () => {
  const { data } = useGetCompanyQuery();
  return data?.result.preferences?.tamara_integration;
};

export default useCanTamara;
